module.exports = __webpack_public_path__ + "img/8577d2c.jpg";